import Model, { attr, belongsTo } from '@ember-data/model';

import { apiAction } from '@mainmatter/ember-api-actions';

export default class PaymentIntentModel extends Model {
  @attr pricePlanId;
  @attr paymentMethodId;
  @attr('boolean') requiresAction;
  @attr clientSecret;
  @attr status;

  @belongsTo('registration', { async: true, inverse: null }) registration;

  async confirm() {
    let response = await apiAction(this, {
      method: 'POST',
      path: 'confirm',
    });
    this.store.pushPayload('payment-intent', response);
  }
}
